<!--
//================================================================================
// ID:BC001
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC001
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
// 01.01.00 | 2023/06/02 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.02.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<div v-if="disp.isKensyoEnv" class="text-kensyo">
			【検証環境】
		</div>
		<div class="div-right">
			<a href="https://www.metro.tokyo.lg.jp/index.html" v-bind:tabindex="-1" target="_blank" rel="noopener noreferrer">
				都庁総合ホームページ
			</a>
		</div>
		<br />
		<caution-item
			v-bind:tyuibunItems="disp.systemTyuiItem"
		/>
		<br />
		<br />
		<section>
			<table class="contents__table--stripe detail table-bordernone">
				<tbody>
					<tr class="table-bordernone">
						<th class="contents__input--title th-style">ユーザID</th>
						<td class="td-style">
							<div>
								<text-input
									class="contents__input--text width-id"
									:modelValue="form.userId"
									:maxLength="255"
									:groupId="'loginInfo'"
									:textType="TEXTINPUT_TYPE.HALF"
									:name="'ユーザID'"
									:requireFlg="true"
									:tabindex="1"
									@update:modelValue="form.userId = $event"
									ref="userId"
								/>
							</div>
						</td>
					</tr>
					<label class="contents__div--MOBILE"><br /></label>
					<tr class="tr-backcolor">
						<th class="contents__input--title th-style">パスワード</th>
						<td class="td-style">
							<div>
								<password-input
									:modelValue="form.password"
									:maxLength="14"
									:groupId="'loginInfo'"
									:name="'パスワード'"
									:requireFlg="true"
									:tabindex="2"
									@update:modelValue="form.password = $event"
									ref="password"
								/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="div-loginInfo">
				<itemerror-message v-bind:groupId="'loginInfo'"/>
			</div>
			<div class="contents__caution--div div-marginleft">
				<div class="contents__caution--div_mark">
					<p class="div-tyui text-lineheight contents__label--tyuui">※</p>
				</div>
				<div>
					<p class="div-tyui text-lineheight contents__label--tyuui">
						パスワードは大文字・小文字を区別しますのでご注意ください。
					</p>
				</div>
			</div>
			<label class="contents__div--PC"><br /><br /></label>
			<div class="contents__div--center">
				<input
					type="submit"
					value="ログイン"
					class="contents__btn--confirm"
					v-bind:tabindex="3"
					@click="doLogin"
					v-bind:disabled="disp.loginBtnDisabledFlg"
				/>
			</div>
			<br />
			<hr />
			<br />
			<div class="contents__div--center">
				<div>
					<label class="text-color text-lineheight">
						パスワードを忘れた方・再設定したい方は、
						<a class="a-LinkPass" style="cursor: hand; cursor:pointer;" v-on:click="clickPwreset" v-bind:tabindex="-1">パスワード再設定へ</a>
					</label>
				</div>
				<br />
				<div>
					<b>
						<label class="text-color text-lineheight">
							初めて利用される方は、
							<label class="contents__div--MOBILE"><br /></label>
							<a class="a-LinkPass" style="cursor: hand; cursor:pointer;" v-on:click="clickRiyoTouroku" v-bind:tabindex="-1">利用者登録へ</a>
						</label>
					</b>
				</div>
				<br />
				<div class="text-center">
					<label class="text-color text-lineheight">
						申込みする住宅を選ぶ方は、
						<label class="contents__div--MOBILE"><br /></label>
						<a class="a-LinkPass" style="cursor: hand; cursor:pointer;" v-on:click="clickJyutakuSearch" v-bind:tabindex="-1">募集住宅検索へ</a>
					</label>
				</div>
				<br />
				<div class="contents__caution--multiple">
					<label class="contents__caution--multiple text-color">
						{{ disp.riyokiyakuTyuiItem[0] }}
						<a v-bind:href="disp.riyokiyakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">{{ disp.riyokiyakuLkMessage }}</a>
					</label>
				</div>
			</div>
			<br />
			<div class="contents__div--left">
				<table
					border="1"
					align="center"
					class="contents__table--width table-width table-padding table-color"
				>
					<tr>
						<td class="td-widthborder">
							<div class="toiawase-padding">
								<label class="labe-lineheight">
									【問合せ】<br />
									<div class="div-marginleft-toiawase">
										東京都住宅供給公社 都営住宅入居者募集サイトコールセンター<br />
										0570-050-410<br />
										営業時間 9:00～18:00（土・日・祝日・年末年始を除く）
									</div>
								</label>
							</div>
						</td>
					</tr>
				</table>
				<br />
			</div>
			<div class="margin__bottom-page">
				<p class="Copyright-align">Copyright (C) 2022 Tokyo Metropolitan Government. All Rights Reserved.</p>
			</div>
		</section>
	</div>
</template>

<script>
import TextInput from '@/components/TextInput.vue';
import PasswordInput from '@/components/PasswordInput.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';
import CautionItem from '@/components/CautionItem.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_isOperation } from '@/common/browserUtility.js'; 
import { co_isEmpty } from '@/common/checkUtility.js';
import { co_toTrans, co_clearParam } from '@/common/screenUtility';

import { STORE_USER_SET_INFO, STORE_ERROR_CLEAR, STORE_ERROR_IS_ERRFLG,
			STORE_ERROR_SET_INPUT_ERR, STORE_VIEW_PROGRESS, STORE_USER_CLEAR, STORE_VIEW_GET_PARAMS } from '@/const/store.js';
import { HTTP_STATUS, ROLE_TYPE, TEXTINPUT_TYPE } from '@/const/const.js';
import { PATH_BC001_LOGINCHECK, PATH_BC001_GETURL, API_CAUTION_ITEMS, API_ENV_PARAMS } from '@/const/route.js';

export default {
	components: {
		'text-input': TextInput,
		'password-input': PasswordInput,
		'itemerror-message': ItemErrorMessage,
		'caution-item': CautionItem
	},
	data() {
		return {
			form: {
				userId: "",
				password: "",
				callViewId: "",
			},
			disp: {
				systemTyuiItem: ['C0057'],		// システム注意文
				riyokiyakuTyuiItem: [],			// 利用規約注意文
				riyokiyakuLkMessage: '',		// 利用規約注意文（リンクメッセージ）
				riyokiyakuLink: '',				// 外部リンクURL
				passResetLink: '',				// パスワード再設定画面リンクURL
				loginBtnDisabledFlg: false,		// ログインボタン活性・非活性フラグ
				isKensyoEnv: false,				// 検証環境有無 活性・非活性フラグ（true：検証環境、false：検証環境でない）
			},
			callViewId: '',						// 遷移先画面ID
			ROLE_TYPE: ROLE_TYPE,
			TEXTINPUT_TYPE: TEXTINPUT_TYPE
		};
	},
	created: async function() {
		// ブラウザチェック
		if(!await co_isOperation()) {
			co_toTrans('BrowserError');
		}

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ユーザ情報初期化
		this.$store.commit(STORE_USER_CLEAR);

		// 前画面からのパラメータを設定
		let params = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC001');
		if (typeof params != 'undefined') {
			this.callViewId = params.callViewId;
		}

		// 画面間パラメータを削除
		co_clearParam('BC006');

		// 利用規約注意文生成
		this.createKiyakuTyuibun();

		// 環境変数取得
		let env = await co_post(API_ENV_PARAMS);
		this.disp.isKensyoEnv = env.isKensyoEnv;

		// フォーカス設定
		this.$refs.userId.focus();
	},
	methods: {
		doLogin: async function () {

			// ログインボタン非活性
			this.disp.loginBtnDisabledFlg = true;

			// エラークリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// エラーチェック
			this.$refs.userId.validate();
			this.$refs.password.validate();

			// 入力チェックエラーが存在しない場合
			if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				
				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				// パラメータ代入
				this.form.callViewId = this.callViewId;

				let self = this;
				let userInfo = await co_post(PATH_BC001_LOGINCHECK, this.form, function (res, handle) {
					if (res.status == HTTP_STATUS.OK) {
						return handle(res);
					} else {
						// ローディング表示終了
						self.$store.commit(STORE_VIEW_PROGRESS, false);
					}
				});

				// ログインボタン活性
				this.disp.loginBtnDisabledFlg = false;

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// ステータスが0以外の場合
				if (userInfo.status != "0") {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "loginInfo",
						msg: userInfo.message,
					});
					return;
				}

				// エラーメッセージが設定されている場合
				if (!co_isEmpty(userInfo.message)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "loginInfo",
						msg: userInfo.message,
					});
					return;
				}

				// 利用者情報設定
				this.$store.commit(STORE_USER_SET_INFO, {
					userId: this.form.userId,
					riyosyaId: userInfo.idRiyosya,
					role: userInfo.generalUser ? ROLE_TYPE.IPPAN_RIYOUSYA : ROLE_TYPE.TOKYOTO_STAFF,
				});

				// 遷移先判定
				if(!co_isEmpty(this.callViewId)){
					// 呼出画面有り
					co_toTrans(this.callViewId);
				} else {
					// 呼出画面無し
					co_toTrans("BC002");
				}

			}

			// ログインボタン活性
			this.disp.loginBtnDisabledFlg = false;
		},
		// パスワード再設定へリンク押下
		clickPwreset: async function() {
			let userInfo = await co_post(PATH_BC001_GETURL);
			this.disp.passResetLink = userInfo.passResetUrl;
			window.location.href = this.disp.passResetLink;
		},
		// 利用者登録へリンク押下
		clickRiyoTouroku: async function() {
			// 利用者仮登録画面へ遷移
			co_toTrans("BC003");
		},
		// 募集住宅検索へリンク押下
		clickJyutakuSearch: async function() {
			// 募集住宅検索画面へ遷移
			co_toTrans("BC005");
		},
		// 利用規約注意文生成
		createKiyakuTyuibun: async function () {

			let params = {tyuibunList: ["C0054"]};
			let val = await co_post( API_CAUTION_ITEMS, params );

			if ( val != null ) {
				for ( let i = 0; i < val.length; i++ ) {
					let sentenceList = [];		// メッセージリスト
					let message = [];			// 画面表示用メッセージ
					let lkMessage = '';			// 画面表示用リンクメッセージ
					let lkUrl = '';				// 外部リンクURL

					sentenceList = val[i].messageNaiyo.split(/\r\n|\n/);
					for ( let j = 0; j < sentenceList.length; j++ ) {
						if (sentenceList[j].indexOf('%A'+ (i)) >= 0) {
							let list = sentenceList[j].split('%A0S');
							message.push(list[0]);
							lkMessage = list[1].replace('%A0E', '');
						} else {
							message.push(sentenceList[j]);
						}
					}

					// URLリンク生成
					if (!co_isEmpty(val[i].lkUrl)) {
						let lkUrlList = val[i].lkUrl.split(/\r\n|\n/);
						for (let i = 0; i < lkUrlList.length; i++) {
							lkUrl = lkUrlList[i].split('：')[1];
						}
					}

					this.disp.riyokiyakuTyuiItem = message;
					this.disp.riyokiyakuLkMessage = lkMessage;
					this.disp.riyokiyakuLink = lkUrl;
				}
			}
		},
	},
};
</script>

<style scoped>
.div-right {
	text-align: right;
}
.div-tyuimargin {
	margin-left: 2%;
	margin-right: 2%;
}
.div-paddingbottom {
	padding-bottom: 20px;
}
.table-bordernone {
	border: none;
}
.tr-backcolor {
	background-color: #fdfdfd;
}
.table-padding {
	padding: 0px 0px 0px 5px;
}
.td-widthborder {
	width: 87%;
	border: none;
}
.text-color {
	color: #fe0000;
}
.text-center {
	text-align: center;
}
.div-fontweight {
	font-weight: normal;
	margin-top: -10px;
}
.a-LinkPass {
	color: #0000EE;
	text-decoration: underline;
}
.a-LinkPass :active {
	color: #551A8B;
	text-decoration: underline;
}
.table-color {
	border: 1px solid #666666;
}
.text-kensyo {
	text-align: left;
	font-size: 270%;
	color: #fe0000;
}
/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.contents__main {
		font-size: 16px;
	}
	.contents__attention {
		list-style: none;
		margin-left: 20px;
		display: inline-flex;
	}
	.label-tyuijikou {
		font-size: 20px;
		margin-left: 1%;
	}
	.div-loginInfo {
		margin-left: 215px;
		width: 63% !important;
		margin-bottom: 18px;
		position: relative;
		left: 35px;
	}
	.width-id {
		width: 48%;
	}
	.detail th:first-child {
		width: 30%;
		text-align: right;
		font-weight: normal;
		vertical-align: middle;
	}
	.detail td:nth-child(2) {
		width: 44%;
	}
	.div-marginleft {
		margin-left: 11%;
		justify-content: center;
	}
	.div-tyui {
		color: #fe0000;
		display: inline;
	}
	.toiawase-padding {
		padding: 5px;
	}
	.th-style {
		border-bottom: none;
	}
	.td-style {
		border-bottom: none;
	}
	.labe-lineheight {
		line-height: 1.7em;
	}
	.div-tyuibunItem {
		margin-left: 3%;
		margin-top: -13px;
	}
	.div-marginleft-toiawase {
		margin-left: 15px;
	}
}
/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.label-tyuijikou {
		font-size: 18px;
		margin-left: 1%;
	}
	.text-lineheight {
		line-height: 1.5em;
	}
	.toiawase-padding {
		padding: 4px;
	}
	.width-id {
		width: 94%;
	}
	.contents__table--stripe th {
		line-height: 2em;
		vertical-align: top;
		padding: 0px 10px 0px 10px;
		position: relative;
	}
	.contents__table--stripe td {
		line-height: 2em;
		vertical-align: top;
		padding: 0px 10px 0px;
		position: relative;
	}
	.th-style {
		font-weight: normal;
		border-bottom: none;
		text-align: left;
	}
	.td-style {
		border-bottom: none;
		text-align: center;
	}
	.div-marginleft {
		width: 90%;
		margin-left: 5%;
	}
	.div-tyui {
		color: #fe0000;
	}
	.labe-lineheight {
		line-height: 1.7em;
		font-size: 16px;
	}
	.table-width {
		width: 99%;
	}
	.div-tyuibunItem {
		margin-top: -13px;
	}
}
</style>